<template>
  <div>
    <el-dialog
      title="扣分上限"
      :modal="false"
      :visible="visible"
      @close="closeDialog"
      custom-class="score-dialog"
      width="80%">
      <div class="dialog-content">
      <el-table
        :data="tableData"
        height="70vh"
        :span-method="objectSpanMethod"
        style="width: 100%">
        <el-table-column prop="categoryName" label="分类"> </el-table-column>
        <el-table-column prop="categoryName2" label="考核项目"> </el-table-column>
        <el-table-column prop="categoryScoreLimit" label="扣分上限">
          <template slot-scope="scope">
<!--            <el-input v-model="scope.row.categoryScoreLimit"
                      @keyup.enter.native="handleCellEdit(scope.row,1)"
                      style="width: 120px"></el-input>-->
            <el-input v-model="scope.row.categoryScoreLimit"
                      @focus="showPlaceholder(scope.$index)"
                      @blur="hidePlaceholder(scope.$index)"
                      @keyup.enter.native="handleCellEdit(scope.row,1)"
                      style="width: 120px">
            </el-input>
            <div v-if="placeholderFlags[scope.$index]&& !scope.row.categoryScoreLimit" class="placeholder">键盘回车键保存</div>
          </template>
        </el-table-column>
        <el-table-column prop="ruleName" label="考核内容"> </el-table-column>
        <el-table-column prop="contentScoreLimit" label="扣分上限">
          <template slot-scope="scope">
            <el-input v-model="scope.row.contentScoreLimit"
                      @focus="showPlaceholderTwo(scope.$index)"
                      @blur="hidePlaceholderTwo(scope.$index)"
                      @keyup.enter.native="handleCellEdit(scope.row,2)"
                      :disabled="scope.row.contentDis"
                      style="width: 120px">
            </el-input>
            <div v-if="placeholderFlagsTwo[scope.$index]&& !scope.row.contentScoreLimit"
                 class="placeholder">键盘回车键保存</div>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="考核评分标准"> </el-table-column>
        <el-table-column prop="scoreLimit" label="扣分上限" class-name="custom-header">
          <template slot-scope="scope">
            <el-input v-model="scope.row.scoreLimit"
                      @focus="showPlaceholderThree(scope.$index)"
                      @blur="hidePlaceholderThree(scope.$index)"
                      @keyup.enter.native="handleCellEdit(scope.row,3)"
                      :disabled="scope.row.scoreDis"
                      style="margin-left: 50px;width: 120px">
            </el-input>
            <div v-if="placeholderFlagsThree[scope.$index]&& !scope.row.scoreLimit"
                 class="placeholder" style="margin-left: 52px;">键盘回车键保存</div>
          </template>
        </el-table-column>
      </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Api from '@/api'
import { mapGetters } from 'vuex'
export default {
  name: 'scoreDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tableData1: [
        { name: '张三', age: 10, name2: '张三2', age2: 0, name3: '张三2', age3: 0 },
        { name: '李四', age: 0, name2: '李四2', age2: 0, name3: '李四2', age3: 0 }
        // 其他表格数据
      ],
      tableData: [],
      placeholderFlags: [],
      placeholderFlagsTwo: [],
      placeholderFlagsThree: []
    }
  },
  computed: {
    ...mapGetters(['selfAreaId'])
  },
  created() {},
  methods: {
    initData() {
      this.tableLoading = true
      const params = {
        selfAreaId: this.selfAreaId
      }
      Api.getScoreLimit(params).then(({ data }) => {
        this.tableData = data
        this.tableData = this.mergeTableRow(this.tableData, [
          'categoryName',
          'categoryName2',
          'categoryScoreLimit',
          'ruleName',
          'contentScoreLimit'
        ])
        this.tableData.forEach((item) => {
          item['categoryScoreLimit-span'] = item['categoryName2-span']
          item['contentScoreLimit-span'] = item['ruleName-span']
        })
        this.scoreLimitDisabled()
        this.tableLoading = false
      })
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      const span = column.property + '-span'
      if (row[span]) {
        return row[span]
      }
    },
    mergeTableRow(data, merge) {
      if (!merge || merge.length === 0) {
        return data
      }
      const mergeCols = ['categoryName', 'categoryName2', 'categoryScoreLimit', 'ruleName', 'contentScoreLimit', 'description'] // 需要进行表格合并的列
      const mergeRules = {} // 合并规则
      mergeCols.forEach((col) => {
        mergeRules[col] = col + '-span'
      })
      merge.forEach((m) => {
        const mList = {}
        data = data.map((v, index) => {
          const rowVal = v[m]
          if (mergeCols.includes(m)) { // 需要进行表格合并的列
            if (mList[rowVal] && mList[rowVal].newIndex === index) {
              mList[rowVal].num++
              mList[rowVal].newIndex++
              data[mList[rowVal].index][mergeRules[m]].rowspan++
              v[mergeRules[m]] = {
                rowspan: 0,
                colspan: 0
              }
            } else {
              mList[rowVal] = {
                num: 1,
                index: index,
                newIndex: index + 1
              }
              v[mergeRules[m]] = {
                rowspan: 1,
                colspan: 1
              }
            }
          } else { // 不进行表格合并的列
            v[mergeRules[m]] = {
              rowspan: 1,
              colspan: 1
            }
          }
          return v
        })
      })
      return data
    },
    closeDialog() {
      this.$emit('close-dialog')
    },
    handleCellEdit(row, type) {
      const flag = this.validateField(row, type)
      if (flag) {
        const params = {
          selfAreaId: this.selfAreaId,
          type: type
        }
        Api.updateScoreLimit(row, params).then((res) => {
          if (res.code === 200) {
            this.initData()
          } else {
            this.$message.warning(res.message)
          }
        })
      }
    },
    validateField(row, type) {
      let flag = true
      // 扣分上限-考核项目
      const categoryEmpty = (row.categoryScoreLimit === '' || row.categoryScoreLimit === null)
      const categoryNotEmpty = (row.categoryScoreLimit !== '' && row.categoryScoreLimit !== null)
      // 扣分上限-考核内容
      const contentNotEmpty = (row.contentScoreLimit !== '' && row.contentScoreLimit !== null)
      // 扣分上限-考核评分标准
      const scoreNotEmpty = (row.scoreLimit !== '' && row.scoreLimit !== null)
      if (type === 1) {
        const inputValue = parseFloat(row.categoryScoreLimit ? row.categoryScoreLimit : 0)
        const pattern = /^[0-9.]+$/
        if (categoryNotEmpty && !pattern.test(inputValue)) {
          this.$message.warning('只允许输入数字和小数点')
          row.categoryScoreLimit = '' // 清空输入框内容
          flag = false
        }
      }
      if (type === 2) {
        if (contentNotEmpty && categoryEmpty) {
          this.$message.warning('请输入考核项目的扣分上限')
          flag = false
        } else {
          const inputValue = parseFloat(row.contentScoreLimit ? row.contentScoreLimit : 0)
          const pattern = /^[0-9.]+$/
          if (contentNotEmpty && !pattern.test(inputValue)) {
            this.$message.warning('只允许输入数字和小数点')
            row.contentScoreLimit = '' // 清空输入框内容
            flag = false
          } else {
            flag = this.validateScore(row, type, flag)
          }
        }
      }
      if (type === 3) {
        const inputValue = parseFloat(row.scoreLimit ? row.scoreLimit : 0)
        const pattern = /^[0-9.]+$/
        if (scoreNotEmpty && !pattern.test(inputValue)) {
          this.$message.warning('只允许输入数字和小数点')
          row.scoreLimit = '' // 清空输入框内容
          flag = false
        } else {
          flag = this.validateScore(row, type, flag)
        }
      }
      return flag
    },
    // 扣分限制校验扣分上限-考核内容分数<=扣分上限-考核项目，扣分上限-考核考核评分标准<=扣分上限-考核内容
    validateScore(row, type, flag) {
      const contentScoreLimit = parseFloat(row.contentScoreLimit ? row.contentScoreLimit : 0) // 当前的扣分上限-考核内容
      const categoryScoreLimit = parseFloat(row.categoryScoreLimit ? row.categoryScoreLimit : 0) // 扣分上限-考核项目
      if (type === 2) {
        const categoryId = row.categoryId // 当前的 categoryId 值
        const ruleNameToExclude = row.ruleName // 需要剔除的 ruleName 值,防止ruleName有重复
        // 过滤出 categoryId 相等并且 examineId 不等于 examineIdToExclude 的对象
        const filteredData = this.tableData.filter(item => item.categoryId === categoryId && item.ruleName !== ruleNameToExclude)
        // 使用 reduce 方法将 scoreLimit 相加
        let totalScoreLimit = filteredData.reduce((accumulator, item) => accumulator + item.contentScoreLimit, 0)
        totalScoreLimit = totalScoreLimit + contentScoreLimit
        if (totalScoreLimit > categoryScoreLimit) {
          this.$message.warning('已超过考核项目的扣分上限总：' + categoryScoreLimit + '分')
          flag = false
        }
      } else {
        // 扣分上限-考核评分标准
        const examineIdToExclude = row.examineId // 需要剔除的 examineId 值
        const scoreLimit = parseFloat(row.scoreLimit ? row.scoreLimit : 0) // 当前的扣分上限-考核评分标准
        // 筛选考核内容相同的对象
        const filteredContentData = this.tableData.filter(item => item.ruleName === row.ruleName)

        // 过滤出 ruleName 相等并且 examineId 不等于 examineIdToExclude 的对象
        const filteredData = this.tableData.filter(item => item.ruleName === row.ruleName && item.examineId !== examineIdToExclude)
        // 使用 reduce 方法将 scoreLimit 相加
        let totalScoreLimit = filteredData.reduce((accumulator, item) => accumulator + item.scoreLimit, 0)
        totalScoreLimit = totalScoreLimit + scoreLimit
        // 扣分上限-考核内容(多条数据时，只要有一条contentScoreLimit不为空，则校验通过)
        const contentNotEmpty = filteredContentData.some(item => item.contentScoreLimit !== '' && item.contentScoreLimit !== null)
        // 扣分上限-考核项目(一级)、扣分上限-考核内容(二级)、扣分上限-考核评分标准(三级)
        // 当二级为空，与三级之和<=一级分数；当二级不为空，二级对应的三级，与三级之和<=二级分数
        if (!contentNotEmpty) {
          if (totalScoreLimit > categoryScoreLimit) {
            this.$message.warning('已超过考核项目的扣分上限总：' + categoryScoreLimit + '分')
            flag = false
          }
        } else {
          if (filteredContentData.length > 1) {
            if (totalScoreLimit > contentScoreLimit) {
              this.$message.warning('已超过考核内容的扣分上限总：' + contentScoreLimit + '分')
              flag = false
            }
          } else {
            if (scoreLimit > contentScoreLimit) {
              this.$message.warning('已超过考核内容的扣分上限总：' + contentScoreLimit + '分')
              flag = false
            }
          }
        }
      }
      return flag
    },
    showPlaceholder(index) {
      this.$set(this.placeholderFlags, index, true)
    },
    hidePlaceholder(index) {
      this.$set(this.placeholderFlags, index, false)
    },
    showPlaceholderTwo(index) {
      this.$set(this.placeholderFlagsTwo, index, true)
    },
    hidePlaceholderTwo(index) {
      this.$set(this.placeholderFlagsTwo, index, false)
    },
    showPlaceholderThree(index) {
      this.$set(this.placeholderFlagsThree, index, true)
    },
    hidePlaceholderThree(index) {
      this.$set(this.placeholderFlagsThree, index, false)
    },
    // 扣分上限-考核项目（一级）为空，扣分上限-考核内容（二级）和 扣分上限-考核考核评分标准(三级)输入框置灰，不可填
    // 扣分上限-考核内容（二级）为空，扣分上限-考核考核评分标准(三级)输入框置灰，不可填
    scoreLimitDisabled() {
      const groupedAndFiltered = {}
      this.tableData.forEach(item => {
        if (!groupedAndFiltered[item.categoryId]) {
          groupedAndFiltered[item.categoryId] = item
        }
      })
      const uniqueTests = Object.values(groupedAndFiltered)
      uniqueTests.forEach(data => {
        const categoryEmpty = (data.categoryScoreLimit === '' || data.categoryScoreLimit === null)
        // 过滤出 categoryId 相等的对象
        this.tableData = this.tableData.map(item => {
          if (item.categoryId === data.categoryId) {
            if (categoryEmpty) {
              return {
                ...item,
                contentDis: true,
                scoreDis: true
              }
            } else {
              return {
                ...item,
                contentDis: false,
                scoreDis: false
              }
            }
          }
          return item // 返回未修改的元素
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
/*扣分上限-考核评分标准样式*/
::v-deep.el-table th:nth-child(7) .cell  {
  margin-left: 60px;
}
.dialog-content {
  height: 70vh;
  overflow: auto;
}
::v-deep .score-dialog .el-dialog__body {
  /* 在这里添加您要修改的样式 */
  padding: 5px 20px;
}
::v-deep .el-input__inner {
  border: 1px solid #ffffff;
}
.placeholder {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  color: #ccc;
  font-style: italic;
}
</style>
